export class State {
  public id: number;
  public code: string;
  public country_id:number;
  public name:string;
  public description:string;
  public country_name:string;
}



// WEBPACK FOOTER //
// ./src/app/models/state.model.ts